module.exports = __webpack_public_path__ + "img/展开.7b230ed1.svg";